export { MenuBoxBigIcon } from './MenuBoxBigIcon';
